import {GetDiscountsResponse_Discount} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.types';
import {useCallback, useMemo} from 'react';
import {useTotalSavings} from '../../../backend-services/Campaigns/TotalSavingsProvider';
import {useGetGenderBanner} from '../../../backend-services/Campaigns/hooks/useGetGenderBanner';

export const useMappedDiscount = ({
  discount,
}: {
  discount?: GetDiscountsResponse_Discount;
}) => {
  const getGenderBanner = useGetGenderBanner();
  const {value: totalSavings} = useTotalSavings();

  const discountData = useMemo(() => {
    if (!discount) {
      return undefined;
    }

    const bannerData = discount;

    const genderTopBanner = getGenderBanner(discount)!;

    return {
      discountId: discount.id,
      backgroundColor: discount.colors.backgroundColor.hex,
      headline: genderTopBanner.headlineText,
      subline: genderTopBanner.sublineText,
      validUntil: bannerData!.campaign.period.endDate,
      conditionText: genderTopBanner.conditionText,
      'data-testid': 'defaultCampaignCard',
      savingsLabel:
        totalSavings?.discountId === discount.id
          ? totalSavings.bannerText
          : undefined,
      showCountdown: genderTopBanner.showCountdown,
      isAppOnly:
        discount.campaign.type?.$case === 'reduction'
          ? discount.campaign.type.reduction.isAppOnlyCampaign
          : false,
    };
  }, [discount, getGenderBanner, totalSavings]);

  return discountData;
};

export const useMappedDiscountsCallback = () => {
  const getGenderBanner = useGetGenderBanner();
  const {value: totalSavings} = useTotalSavings();

  return useCallback(
    ({discount}: {discount?: GetDiscountsResponse_Discount}) => {
      if (!discount) {
        return undefined;
      }

      const bannerData = discount;

      const genderTopBanner = getGenderBanner(discount)!;

      return {
        discountId: discount.id,
        backgroundColor:
          discount.colors.backgroundColor.hex ||
          genderTopBanner.backgroundColor,
        headline: genderTopBanner.headlineText,
        subline: genderTopBanner.sublineText,
        validUntil: bannerData!.campaign.period.endDate,
        conditionText: genderTopBanner.conditionText,
        'data-testid': 'defaultCampaignCard',
        savingsLabel:
          totalSavings?.discountId === discount.id
            ? totalSavings.bannerText
            : undefined,
        showCountdown: genderTopBanner.showCountdown,
        endsAt: bannerData!.campaign.period.endDate,
      };
    },
    [getGenderBanner, totalSavings],
  );
};
